/**
 * Yalnız arayüz tercihleri tarayıcıda saklanır (plan §5: "localStorage yalnız tercih"). Kişisel veri, belirteç veya
 * sunucu yanıtı buraya yazılmaz. Depolama erişilemezse (gizli pencere, politika) varsayılan kullanılır.
 * v3.9: eski kenar çubuğu daraltma ve menü grubu tercihleri alan navigasyonuyla birlikte kaldırıldı.
 */

/**
 * Çalışma alanı + kullanıcı başına tutulan tercihlerin anahtarına ham kimlik YAZILMAZ, yalnız ikisinin kısa özeti girer —
 * aynı tarayıcıyı paylaşan iki hesabın seçimi karışmaz, depoda kişiyi gösteren değer kalmaz. 32 bit FNV-1a, 8 hane
 * onaltılık (kimlik değil, yalnız tercih anahtarı ayrımı).
 */
export function preferenceDigest(text: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h.toString(16).padStart(8, '0');
}

/**
 * v3.9 alan navigasyonu: bağlamsal panelin gizli olup olmadığı (yalnız ≥ 1024 px yerleşik panel). Tanımsızsa panel açık.
 */
const PANEL_HIDDEN_KEY = 'cf.ui.navPanelHidden.v1';

export function readPanelHiddenPreference(): boolean | null {
  try {
    const v = window.localStorage.getItem(PANEL_HIDDEN_KEY);
    return v === '1' ? true : v === '0' ? false : null;
  } catch {
    return null;
  }
}

export function writePanelHiddenPreference(hidden: boolean): void {
  try {
    window.localStorage.setItem(PANEL_HIDDEN_KEY, hidden ? '1' : '0');
  } catch {
    // Tercih kaydedilemezse oturum boyunca bellekte kalır
    return;
  }
}

/**
 * v3.9 hızlı erişim: sabitlenen sayfaların menü öğe kimlikleri (yalnız ürün sabiti kimlikler, sıra korunur). Çalışma alanı +
 * kullanıcı başına ayrı anahtar (ham kimlik yazılmaz; `preferenceDigest`). Yalnız TERCİHTİR: görünürlük her çizimde yetki
 * süzgecinden geçen menüden seçilir — yetkisi kalkmış sayfa sabitlenmiş olsa da gösterilmez (doğrudan adres sunucuda korunur).
 */
const PINS_PREFIX = 'cf.ui.pins.v1.';
export const MAX_PINS = 6;
const ITEM_ID = /^[a-z][a-z0-9-]{0,40}$/;

export function pinsKey(tenantId: string, userId: string): string {
  return `${PINS_PREFIX}${preferenceDigest(`${tenantId}:${userId}`)}`;
}

export function parsePins(raw: string | null): string[] {
  if (raw === null) return [];
  try {
    const v = JSON.parse(raw) as unknown;
    if (!Array.isArray(v)) return [];
    const out: string[] = [];
    for (const x of v)
      if (typeof x === 'string' && ITEM_ID.test(x) && !out.includes(x) && out.length < MAX_PINS)
        out.push(x);
    return out;
  } catch {
    return [];
  }
}

export function readPins(key: string | null): string[] {
  if (key === null) return [];
  try {
    return parsePins(window.localStorage.getItem(key));
  } catch {
    return [];
  }
}

export function writePins(key: string | null, ids: readonly string[]): void {
  if (key === null) return;
  try {
    window.localStorage.setItem(key, JSON.stringify(ids.slice(0, MAX_PINS)));
  } catch {
    // Tercih kaydedilemezse oturum boyunca bellekte kalır
    return;
  }
}
